import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import API from "../../apiService.js";
import Alert from "../component/Alert";
import AlertWithButton from "../component/Alert";
import SicknessPrint from "../medical/SicknessPrint.js";
import moment from "moment";
import PrintButton from "../medical/PrintButton";

export default class Sickness extends Component {
  constructor(props) {
    var d = new Date();
    super(props);
    this.state = {
      sickness: this.props.detilPx.sickness,
      sickness_log: [],
      patients: this.props.detilPx,
      letter_code: "",
      id: "",
      number: this.props.detilPx.sickness
        ? this.props.detilPx.sickness.number.substr(
            0,
            this.props.detilPx.sickness.number.indexOf("/")
          )
        : "",
      permit_date: this.props.detilPx.sickness
        ? this.props.detilPx.sickness.permit_date
        : moment(d).format("YYYY-MM-DD"),
      permit_day: this.props.detilPx.sickness
        ? this.props.detilPx.sickness.permit_day
        : 3,
      explanation: this.props.detilPx.sickness
        ? this.props.detilPx.sickness.explanation
        : "-",
      created_at: this.props.detilPx.sickness
        ? this.props.detilPx.sickness.created_at
        : moment(d).format("YYYY-MM-DD"),
      profile: {
        villages: null,
      },
    };

    this.handleChange = this.handleChange.bind(this);
  }

  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  setAge(d) {
    var age = moment().diff(d, "years", true);
    return Math.floor(age);
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  componentDidMount() {
    this.getLetter();
    this.getQueue();
    this.getSickness();
  }

  getSickness = async () => {
    var d = new Date();
    const res = await API.get(
      "registration/sickness/read/" + this.state.patients.id
    );

    if (res.code === 200) {
      this.setState({
        sickness: res.data[0],
        sickness_log: res.data,
        number: res.data
          ? res.data[0].number.substr(0, res.data[0].number.indexOf("/"))
          : 1,
        permit_date: res.data
          ? res.data[0].permit_date
          : moment(d).format("YYYY-MM-DD"),
        permit_day: res.data ? res.data[0].permit_day : 3,
        explanation: res.data ? res.data[0].explanation : "-",
        created_at: res.data
          ? res.data[0].created_at
          : moment(d).format("YYYY-MM-DD"),
      });
    }
  };

  getQueue = async () => {
    var d = new Date();
    const res = await API.get(
      "registration/sickness/select/" + moment(d).format("YYYY-MM")
    );
    if (res.code === 200) {
      if (this.state.number == "") {
        this.setState({
          number: res.data,
        });
      }
    }
  };

  handleSend = async () => {
    const res = await API.put("registration/sickness/update", {
      id: this.state.sickness ? this.state.sickness.id : null,
      visit_id: this.state.patients.id,
      number: this.state.number + this.state.letter_code,
      permit_date: this.state.permit_date,
      permit_day: this.state.permit_day,
      explanation: this.state.explanation,
    });
    if (res.code === 200) {
      this.setState(
        {
          created_at: res.data.created_at,
          sickness: res.data,
        },
        function () {
          this.getSickness();
        }
      );
      Alert("success", "Sukses menyimpan data surat keterangan sakit pasien");
    } else {
      AlertWithButton(
        "warning",
        "Gagal menyimpan data surat keterangan sakit pasien\nPeriksa kembali isian data anda"
      );
    }
  };

  romanize = (num) => {
    if (!+num) return "";
    var digits = String(+num).split(""),
      key = [
        "",
        "C",
        "CC",
        "CCC",
        "CD",
        "D",
        "DC",
        "DCC",
        "DCCC",
        "CM",
        "",
        "X",
        "XX",
        "XXX",
        "XL",
        "L",
        "LX",
        "LXX",
        "LXXX",
        "XC",
        "",
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
      ],
      roman = "",
      i = 3;
    while (i--) roman = (key[+digits.pop() + i * 10] || "") + roman;
    return Array(+digits.join("") + 1).join("M") + roman;
  };

  getLetter = async () => {
    const res = await API.get(
      "management/profiles/read?code=" +
        JSON.parse(localStorage.getItem("userData")).puskesmas_id
    );
    var d = new Date();
    if (res.code === 200) {
      var code =
        "/" +
        res.data.nama_singkat +
        "/" +
        this.romanize(d.getMonth() + 1) +
        "/" +
        d.getFullYear();
      this.setState({
        profile: res.data,
        letter_code: code,
      });
    }
  };

  render() {
    let color = this.state.sickness_log.find((set) => set.log) ? "#5e72e4" : "";
    const log = this.state.sickness_log.map((sickness_log, keys) => {
      return sickness_log.log ? (
        <li
          className='checklist-entry list-group-item align-items-start'
          key={keys}>
          <div className='d-flex w-100 justify-content-between'>
            <div>
              <div className='d-flex w-100 align-items-center'>
                <h3 className='mb-1'>{sickness_log.doctor.name}</h3>
              </div>
            </div>
            <small>
              {moment(sickness_log.created_at).format("DD-MM-YYYY HH:mm:ss")}
            </small>
          </div>
          <div className='row'>
            <div className='col-4'>Nomor</div>
            <div className='col-8'>
              : <mark>{sickness_log.number}</mark>
            </div>
          </div>
          <div className='row'>
            <div className='col-4'>Jumlah Hari</div>
            <div className='col-8'>
              : <mark>{sickness_log.permit_day} Hari</mark>
            </div>
          </div>
          <div className='row'>
            <div className='col-4'>Mulai dari Tanggal</div>
            <div className='col-8'>
              :{" "}
              <mark>
                {moment(sickness_log.permit_date).format("DD-MM-YYYY")}
              </mark>
            </div>
          </div>
          <div className='row'>
            <div className='col-4'>Keterangan</div>
            <div className='col-8'>
              : <mark>{sickness_log.explanation}</mark>
            </div>
          </div>
        </li>
      ) : (
        ""
      );
    });
    return (
      <div className='row'>
        <div className='col-12'>
          <div className='card'>
            <div className='card-header'>
              <div className='row align-items-center'>
                <div className='col-8'>
                  <h4 className='h3 mb-0'>Form Surat Keterangan Sakit</h4>
                </div>
                {this.state.sickness ? (
                  <div className='col-4 text-right'>
                    <PrintButton
                      url={`/registration/sickness/print/${this.state.sickness.id}`}
                      buttonText='Cetak'
                      color='neutral'
                    />
                    {/* <button
                      type='button'
                      className='btn btn-sm btn-neutral'
                      data-toggle='collapse'
                      data-target='#collapsePreview'
                      aria-expanded='false'
                      aria-controls='collapsePreview'>
                      <span className="btn-inner--icon"><i className="fas fa-eye"></i></span>
                      <span className="btn-inner--text"> Pratinjau</span>
                    </button>
                    <ReactToPrint
                      trigger={() => (
                        <a href="#">
                          <button className="btn btn-sm btn-neutral" type="button" >
                            <span className="btn-inner--icon"><i className="fa fa-print"></i></span>
                            <span className="btn-inner--text"> Cetak</span>
                          </button>
                        </a>
                      )}
                      content={() => this.componentRef}
                    /> */}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className='collapse' id='collapsePreview'>
                <br></br>
                <div className='list-group-item' style={{ display: "block" }}>
                  <SicknessPrint
                    ref={(el) => (this.componentRef = el)}
                    detilPx={this.state.patients}
                    sickness={this.state.sickness}
                    profile={this.state.profile}
                  />
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div className='row align-items-center'>
                <div className='col-12'>
                  {this.state.patients.paramedic_id ? (
                    ""
                  ) : (
                    <div
                      className='alert alert-danger alert-dismissible fade show'
                      role='alert'>
                      <span className='alert-text'>
                        <strong>Pemberitahuan!</strong> Belum dilakukan
                        pemeriksaan kepada pasien.
                      </span>
                      <button
                        type='button'
                        className='close'
                        data-dismiss='alert'
                        aria-label='Close'>
                        <span aria-hidden='true'>×</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label>Nomor</label>
                    <div className='row'>
                      <div className='col-3'>
                        <input
                          className='form-control'
                          value={this.state.number}
                          name='number'
                          type='number'
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className='col-9'>
                        <input
                          className='form-control'
                          value={this.state.letter_code}
                          type='text'
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-3'>
                  <div className='form-group'>
                    <label>Jumlah Hari</label>
                    <input
                      className='form-control'
                      value={this.state.permit_day}
                      name='permit_day'
                      type='number'
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className='col-9'>
                  <div className='form-group'>
                    <label>Dimulai dari Tanggal</label>
                    <input
                      className='form-control datepicker'
                      value={this.state.permit_date}
                      name='permit_date'
                      type='date'
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label>Keterangan</label>
                    <textarea
                      className='form-control'
                      value={this.state.explanation}
                      name='explanation'
                      placeholder='Keterangan'
                      rows='3'
                      type='text'
                      onChange={this.handleChange}></textarea>
                  </div>
                </div>
              </div>
              {this.state.patients.paramedic_id ? (
                <button className='btn btn-primary' onClick={this.handleSend}>
                  Simpan Surat Sakit
                </button>
              ) : (
                ""
              )}
              <button className='btn btn-danger' onClick={this.onReload}>
                Tutup
              </button>
            </div>
            {/* <div className="row">
            <div className="col-12">
              <ul className="list-group">
                <li className="list-group-item" key="0">
                  <div className="row align-items-center">
                    <div className="col-12">
                      <a href="#!" style={{ float: 'left', marginTop: '12Px' }} className="avatar avatar-xl">
                        <img alt="Image placeholder" src="http://gunungkidulkab.go.id/images/logo.png" />
                      </a>
                      <h3 className="text-center">{this.state.profile.report_header_2}<br></br>
                        {this.state.profile.report_header_1}<br></br>
                        {this.state.profile.name}</h3>
                      <div className="text-center">{this.state.profile.address} Telp. {this.state.profile.phone}</div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item" key="1">
                  <div className="row align-items-center">
                    <div className="col-12">
                      <div className="text-center"><u><strong>SURAT KETERANGAN SAKIT</strong></u><br></br>No. {this.state.sickness ? this.state.sickness.number : ''}</div><br></br>
                    </div>
                    <div className="col-12">
                      Yang bertanda tangan dibawah ini Dokter {this.state.profile.name} {this.state.profile.villages ? this.state.profile.villages.district.city.name : ''}, dengan ini menerangkan bahwa :
                    </div>
                    <div className="col-4">
                      Nama
                    </div>:
                    <div className="col-7">
                      {this.state.sickness ? (this.state.patients.patients.name).toUpperCase() : ''}
                    </div>
                    <div className="col-4">
                      Jenis Kelamin
                    </div>:
                    <div className="col-7">
                      {this.state.sickness ? (this.state.patients.patients.sex).toUpperCase() : ''}
                    </div>
                    <div className="col-4">
                      Tempat, Tanggal Lahir
                    </div>:
                    <div className="col-7">
                      {(this.state.patients.patients.birth_place).toUpperCase()}, {moment(this.state.patients.patients.birth_date).format('DD-MM-YYYY')}{' '}({Age} TH)
                    </div>
                    <div className="col-4">
                      Pekerjaan
                    </div>:
                    <div className="col-7">
                      {this.state.sickness ? (this.state.patients.patients.job.name).toUpperCase() : ''}
                    </div>
                    <div className="col-4">
                      Alamat
                    </div>:
                    <div className="col-7">
                      {(this.state.patients.patients.address).toUpperCase()}, {this.state.patients.villages.name}, {this.state.patients.villages.district.name}, {this.state.patients.villages.district.city.name}, {this.state.patients.villages.district.city.province.name}
                    </div>
                    <div className="col-12"><br></br>
                      Pada saat pemeriksaan dalam keadaan sakit, sehingga perlu istirahat selama {this.state.permit_day} hari,<br></br>
                      Mulai tanggal {moment(this.state.permit_date).format('DD-MM-YYYY')} s.d. tanggal {moment(this.state.permit_date).clone().add(this.state.permit_day, 'days').format('DD-MM-YYYY')}. Dengan diagnosa :
                    </div>
                    <div className="col-12">
                      <strong>{this.state.explanation}</strong><br></br><br></br>
                    </div>
                    <div className="col-12">
                      Demikian Surat Keterangan ini dibuat, dengan mengingat sumpah saat menerima jabatan, agar dapat digunakan sebagaimana mestinya.<br></br><br></br>
                    </div>
                    <div className="col-6"></div>
                    <div className="col-6">
                      <div className="text-center">
                        {this.state.profile.villages ? (this.state.profile.villages.district.city.name).replace('KABUPATEN ', '') : ''}, {moment(this.state.created_at).format('DD MMMM YYYY')}<br></br>
                        Dokter Pemeriksa<br></br>
                        <br></br>
                        <br></br>
                        {this.state.patients.paramedic.name}<br></br>
                        NIP. {this.state.patients.paramedic.nip}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div> */}
          </div>
        </div>
        <div className='col-12'>
          <div
            style={{ width: "100%" }}
            className='accordion'
            id='accordionLog'>
            <div className='card'>
              <div
                className='card-header'
                id={"heading"}
                data-toggle='collapse'
                data-target={"#collapse"}
                aria-expanded='false'
                aria-controls={"collapse"}>
                <div
                  style={{ color: color }}
                  className='h3 checklist-title mb-0'>
                  Histori Surat Keterangan Sakit
                </div>
              </div>
              <div
                id={"collapse"}
                className='collapse'
                aria-labelledby={"heading"}
                data-parent='#accordionLog'>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-12'>
                      <ul className='list-group'>{log}</ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
